import { ArrowRight } from "lucide-react";

export const WEBINARJAM_URL = "https://event.webinarjam.com/o1zox7/register/qwkq75sm";

export const CtaButton = ({ testId, children }) => (
  <a
    data-testid={testId}
    href={WEBINARJAM_URL}
    target="_blank"
    rel="noopener noreferrer"
    className="group inline-flex items-center gap-2 rounded-full bg-sage px-8 py-4 text-base font-semibold text-white transition-[transform,background-color] duration-300 hover:bg-sage-dark hover:scale-[1.03]"
  >
    {children}
    <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
  </a>
);
